import { render, staticRenderFns } from "./sso-layout.vue?vue&type=template&id=6fb81d34&scoped=true"
import script from "./sso-layout.vue?vue&type=script&lang=js"
export * from "./sso-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb81d34",
  null
  
)

export default component.exports